import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Wraps a protected route. Redirects to the appropriate login page
 * if the user isn't authenticated with the required role.
 */
export default function RequireAuth({ role, children }) {
  const { auth } = useAuth();
  const { id }   = useParams();

  // Display view needs no auth.
  if (role === 'display') return children;

  if (!auth) {
    return <Navigate to={`/session/${id}/${role}/login`} replace />;
  }

  if (auth.role !== role) {
    // Wrong role — send them to the right login.
    return <Navigate to={`/session/${id}/${role}/login`} replace />;
  }

  return children;
}
